export const filterConditionIsnotnullIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="9.997" cy="10" rx="9.088" ry="9.091" stroke-width="1.818"/><path d="M19 1L1 19" stroke-width="1.8"/></svg>`,
  name: 'filter-condition-isnotnull',
};
